import {
  type FrameOptionsProps,
  frameOptionsDefault,
} from "@/utils/constants/frameOptionsDefault";
import { PaperOptionsProps } from "@/utils/constants/paperOptionsDefault";
import { PAPER_OPTIONS, PAPER_TYPES_MATTE } from "@/utils/content/paperLabels";

export type FrameProps = {
  display: boolean;
  frameOptions: FrameOptionsProps;
  paperOptions: PaperOptionsProps;
  productType: string;
  treatmentOptions: {
    subcategory: string;
    type: string;
  };
  /** Staff mount-only treatment ("Mounted (on substrate)"): substrate / brace / cleat / floater (utils/content/mountOnly.ts). */
  mountOnly?: import("@/utils/content/mountOnly").MountOnlySpec | null;
};

export const frameProps: FrameProps = {
  display: false,
  frameOptions: frameOptionsDefault,
  productType: "Fine Art Print",
  paperOptions: {
    finish: 0,
    label: PAPER_OPTIONS[0],
    paper: PAPER_TYPES_MATTE[0].label,
    size: 0,
    style: 1,
    type: "type1",
  },
  treatmentOptions: {
    subcategory: "",
    type: "No Frame",
  },
};
